import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ErrorBoundary as RollbarErrorBoundary } from "@rollbar/react";
import { actionCreators } from "./redux/commonPageSaga";
import { isModuleActive } from "../../utils/modules";
import LoadingAnimation from "../../components/loadingAnimation/loadingAnimation";
import ModulesConfigurator from "../../components/modulesConfigurator/modulesConfigurator";
import { FallbackComponent } from "../../components/errorBoundary/errorBoundary";
import { useChaseIqAccess } from "../../hooks/useChaseIqAccess";

const ModulesRenderer = ({ pageConfig, renderFilters, renderAI }) => {
  const dispatch = useDispatch();
  const { pageName, moduleList, configuratorWidth, hideConfigurator } = pageConfig;
  const {
    moduleProps,
    preferences,
    isPageLoading,
    commonProps: { allSites }
  } = useSelector((state) => state.commonReducer);

  const hasAIAccess = useChaseIqAccess();

  useEffect(() => {
    dispatch(actionCreators.fetchModulesData({ pageName }));
  }, []);

  return isPageLoading ? (
    <LoadingAnimation />
  ) : (
    <>
      {!allSites && hasAIAccess && renderAI && renderAI()}
      {renderFilters && renderFilters()}
      {hideConfigurator ? null : (
        <div className="configurator-wrapper">
          <div id="pageConfigurator">
            <ModulesConfigurator
              configuratorWidth={configuratorWidth}
              pageName="page"
              buttonLabel={pageName}
              pagePreferences={preferences}
              updatePreferences={(newListFiltered) => {
                dispatch(actionCreators.updatePreferences(newListFiltered));
              }}
            />
          </div>
        </div>
      )}
      <div id="pageModulesWrapper">
        {moduleList.map(({ Component, moduleName }) => (
          <div
            key={moduleName}
            id={`${moduleName.toLowerCase()}ModuleWrapper`}
            className={`moduleWrapper ${hideConfigurator ? "active" : ""}`}
          >
            {isModuleActive(preferences, moduleName) && (
              <RollbarErrorBoundary
                level="error"
                fallbackUI={FallbackComponent}
                extra={{ moduleName }}
              >
                <Component {...moduleProps[moduleName]} />
              </RollbarErrorBoundary>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default ModulesRenderer;
